import { css } from 'styled-components';
import { styleSizes } from 'constants/styleSizes';

export const bookingStepContainerStyles = css`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

export const bookingStepContentStyles = css`
  display: flex;
  justify-content: center;
  align-items: flex-start;
`;

export const roomSelectionMobileStyles = css`
  @media only screen and (max-width: ${styleSizes.miniBreakpoint}) {
    .background {
      display: none;
    }

    .content {
      flex-direction: column;
    }
  }
`;
